import React, { memo } from 'react';
import makeStyles from '@mui/styles/makeStyles';
import { useSidePanelContext } from 'modules/rootPage/SidePanelContext';
import { useSubstituteUser } from 'modules/rootPage/hooks/useSubstituteUser';
import { CollectorListTabs } from './CollectorListTabs';
import CollectorSyncStatusContextProvider from './contexts/CollectorSyncStatusContextProvider';

type PageStyleProps = {
  pinned: boolean;
  isSubstituteUser: boolean;
};

const useStyles = makeStyles((theme) => ({
  root: {
    borderRadius: 'unset',
    overflow: 'hidden',
    marginTop: ({ isSubstituteUser }: PageStyleProps) =>
      isSubstituteUser ? theme.spacing(4) : 'unset',
    boxShadow: theme.shadow?.paper,
    backgroundColor: theme.palette.background.default,
    flexGrow: 1,
    paddingLeft: ({ pinned }: PageStyleProps) =>
      theme.spacing(pinned ? 29.8 : 7.8)
  }
}));

export const CollectorsPage: React.FC = memo(() => {
  const { isSubstituteUser } = useSubstituteUser();
  const { pinned = false } = useSidePanelContext();
  const classes = useStyles({
    pinned,
    isSubstituteUser
  });

  return (
    <CollectorSyncStatusContextProvider>
      <div data-testid="collectors-page" className={classes.root}>
        <CollectorListTabs />
      </div>
    </CollectorSyncStatusContextProvider>
  );
});

CollectorsPage.displayName = 'CollectorsPage';
